var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"full-image",attrs:{"before-close":_vm.close,"modal":true}},[_c('div',{staticClass:"mask",on:{"click":_vm.close}}),_c('div',{staticClass:"image-box",on:{"click":_vm.close}},[_c('img',{attrs:{"src":_vm.url},on:{"click":function($event){$event.stopPropagation();}}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }